import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import AdsCard from '@components/AdsCard';
import CommunityActions from '~/actions/community';
import CompanyActions from '~/actions/company';
import VendorActions from '~/actions/vendor';
import { convertUrl, getHtmlImages } from '~/services/util';
import Card from './Card.jsx';

const PremiumBlogs = ({ data, title, adsList, loading }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.app.user?.community_user);
    const [adsIdx, setAdsIdx] = useState(Math.round(Math.random() * adsList.length));

    const handleClick = (e) => () => {
        const payload = {
            data: {
                community_user_id: user?.id,
                events: [{ content_id: e.id, source: 'home', type: 'click' }],
            },
        };
        dispatch(CommunityActions.addcontenteventRequest(payload, false));
        if (e.data?.blog_company_id) {
            dispatch(
                VendorActions.getvrcompanydetailRequest({
                    companyId: e.data.blog_company_id,
                    callback: handleCompanyCallback(e),
                })
            );
        } else {
            dispatch(CommunityActions.getcommunityuserRequest({ userId: e.author.id, blogId: e.blog.id }, null, null, null, false));
            window.location = e?.data?.permalink;
        }
    };

    const handleCompanyCallback = (post) => (e) => {
        if (e?.company?.business_id) {
            const payload = { id: e.company.business_id };
            const route = { pathname: post?.data?.permalink, state: { post } };
            dispatch(CompanyActions.getbusinessRequest(payload, route));
        }
    };

    const handleOpenProfile = (e) => () => {
        dispatch(CommunityActions.getcommunityuserRequest({ userId: e.author.id }));
        window.location = `/${e.author.entity.slug}/about`; //?user_id=${e.author.id}`
    };

    useEffect(() => {
        const content_id = data.map((x) => x.id);
        const payload = {
            data: {
                community_user_id: user?.id,
                events: [{ content_id, source: 'home', type: 'impression' }],
            },
        };
        dispatch(CommunityActions.addcontenteventRequest(payload, loading));
    }, []);

    useEffect(() => {
        setAdsIdx(Math.round(Math.random() * adsList.length));
    }, [adsList.length]);
    const adsData = adsList[adsIdx];

    return (
        <div className="recent-blogs-feed">
            <p className="dsl-b18 bold blogs-title cursor-pointer">
                <a className="dsl-b18 text-600" href="https://www.drivingsales.com/automotive-blogs">
                    {title}
                </a>
            </p>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <div key={item.id}>
                        {index === 2 ? <broadstreet-zone zone-id="99543"></broadstreet-zone> : <></>}
                        {index === 7 ? <broadstreet-zone zone-id="99538"></broadstreet-zone> : <></>}
                        <Card
                            avatar={convertUrl(item.author_avatar)}
                            date={moment(item.created_at).format('MMM DD, YY')}
                            images={getHtmlImages(item.data.body)}
                            index={index}
                            stats={item.stats}
                            text={item.body_text}
                            title={item.name}
                            user={item.author}
                            company={item.blog.company}
                            appId={user?.id}
                            onClick={handleClick(item)}
                            onOpen={handleOpenProfile(item)}
                        />
                    </div>
                ))
            ) : adsData ? (
                <>
                    <AdsCard className="mb-2" size="medium" data={adsData} />
                    <AdsCard className="mb-2" size="small" data={adsData} />
                </>
            ) : (
                <p className="dsl-m14 mt-4 text-center">No posts to display.</p>
            )}
        </div>
    );
};

PremiumBlogs.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    adsList: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            img: PropTypes.string,
            img_small__300: PropTypes.string,
            img_medium__800: PropTypes.string,
            sponsor: PropTypes.string,
            url__target: PropTypes.string,
        })
    ),
};

PremiumBlogs.defaultProps = {
    adsList: [],
    data: [],
    title: '',
};

export default PremiumBlogs;
